import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { resolveWebClientUiEnabled } from '@/shared/composables/user-features/access-ui-resolvers'
import { pathNames } from '@/shared/utils/constants'

export const webClientBeforeEnter = (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): void => {
  if (!resolveWebClientUiEnabled()) {
    next({ name: pathNames.MAIN })
    return
  }
  next()
}
